import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import {
    setPrivateTablePermissions,
    updateGridTiles,
    updateHomePageRecommendedData,
} from "@/Poker/redux/slices/lobbySlice";
import useApiRequest from "./useApiRequest";
import { useChannel, useAccessToken } from "../data/useLobby";

const useHomePageData = () => {
    const dispatch = useDispatch();
    const channel = useChannel();
    const accessToken = useAccessToken();
    const homePageAPIEndPoint = import.meta.env.VITE_REACT_APP_HOME_PAGE_REQUEST;

    const shouldFetch = !!channel && !!accessToken;
    const config = {
        url: homePageAPIEndPoint,
        method: "POST",
        data: { channel },
        headers: {
            Authorization: accessToken,
        },
    };

    const { data: data, meta: meta, send: send } = useApiRequest(config, false);
    // const { data: data2, meta: meta2, send: send2 } = useApiRequest(config, false);

    useEffect(() => {
        if (shouldFetch) {
            send();
            // console.log("Delay available");
            // const timer = setTimeout(() => {
            //     send();
            // }, 5000); // 4 seconds delay

            // // const duplicateTimer = setTimeout(() => {
            // //     console.log("Triggering duplicate HomePage API request");
            // //     send();
            // // }, 5000); // 0.5 seconds later
        }
    }, [shouldFetch]);

    useEffect(() => {
        if (data) {
            const newLobbyData = data?.message?.newLobbyData;
            if (newLobbyData) {
                let tilesData = newLobbyData.find((item) => item.type === "tiles");
                if (tilesData) {
                    tilesData.data = tilesData.data
                        .filter((_, index) => index < 3);
                    dispatch(updateGridTiles({ gridTiles: tilesData?.data ?? [] }));
                }
                let recommendedData = newLobbyData.find(
                    (item) => item.type === "recommended"
                );
                if (recommendedData) {
                    dispatch(
                        updateHomePageRecommendedData({
                            lbGameDefIds: recommendedData.data,
                        })
                    );
                }
                let privateTableData = newLobbyData.find(
                    (item) => item.type === "privateTables"
                );
                if (privateTableData && privateTableData.data) {
                    let ptData = privateTableData.data;
                    dispatch(
                        setPrivateTablePermissions({
                            allowedToHostPT: ptData.allowedToHostPT,
                            allowedToJoinPT: ptData.allowedToJoinPT,
                        })
                    );
                }
            }
        }
    }, [data]);

    return { };
};

export default useHomePageData;